import { render, staticRenderFns } from "./changeShipping.vue?vue&type=template&id=f6d7baee&scoped=true&"
import script from "./changeShipping.vue?vue&type=script&lang=js&"
export * from "./changeShipping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d7baee",
  null
  
)

export default component.exports